type iUserType= Readonly<"TEACHER" | "STUDENT" | "PARENT">
export default class Person {
    /**
     * 用户ID
     */
    public userId: string;
    /**
     * 用户名
     */
    public username: string;
    /**
     * 真实姓名(需考虑少数民族的名称超长)
     */
    public fullname: string;
    /**
     * 用户编号，学生学号，教职工编号
     */
    public no: string;
    /**
     * 用户类型
     * TEACHER(1, "教师"),
     * STUDENT(2, "学生"),
	 * PARENT(3, "家长"),
     */
    public userType: iUserType;
    /**
     * 拼音
     */
    public pinyin: string;
    /**
     * 头像
     */
    public avatar: string;
     /**
     * 手机
     */
    public mobile: string;
    /**
     * 用户可用状态
     */
    public enableFlag: boolean;
    /**
     * 租户ID
     */
    public tenantId: string;
    /**
     * 租户名字
     */
    public tenantName: string;
    /**
     * 用户组织信息
     */
    public defaultOrganization: any;
    
    constructor({ 
        userId = '', 
        username = '', 
        fullname = '',
        no = '', 
        userType = '', 
        pinyin = '', 
        avatar = '', 
        mobile = '', 
        enableFlag = false, 
        tenantId = '', 
        tenantName = '', 
        defaultOrganization = null
    } = {}) {
        this.userId = userId;
        this.username = username;
        this.fullname = fullname;
        this.no = no;
        this.userType = userType as iUserType;
        this.pinyin = pinyin;
        this.avatar = avatar;
        this.mobile = mobile;
        this.enableFlag = enableFlag;
        this.tenantId = tenantId;
        this.tenantName = tenantName;
        this.defaultOrganization = defaultOrganization;
    }
}